import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Box, Text } from './index';

var Placeholder = function Placeholder(_ref) {
  var message = _ref.message,
      props = _objectWithoutProperties(_ref, ["message"]);

  return React.createElement(Box, _extends({
    height: "100%",
    "min-height": "64px",
    background: "rgba(228, 232, 236, 0.2)",
    border: "2px dashed --color-lightD2",
    "align-items": "center",
    "justify-content": "center",
    display: "flex"
  }, props), React.createElement(Text, {
    "font-family": "--sans",
    "font-size": "16px",
    "line-height": "1.2",
    "font-weight": "300",
    "letter-spacing": "1.5px",
    "text-align": "center",
    color: "palegrey",
    opacity: "0.8"
  }, message));
};

export default Placeholder;